import React from 'react';
import { Instagram } from 'lucide-react';
import { Wordmark } from '../site/Wordmark';
const INSTAGRAM_URL = 'https://www.instagram.com/spacesbetween.studio/?e=8a1d9139-d79e-4586-8628-d78c8089d19c&g=5';
export function Footer() {
  return <footer className="bg-ink pt-16 pb-8 px-6 relative" data-id="element-112">
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-brass/20" data-id="element-113"></div>

      <div className="container mx-auto max-w-7xl" data-id="element-114">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-24" data-id="element-115">
          {/* Left Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-116">
            <Wordmark variant="horizontal" color="white" className="mb-6" data-id="element-117" />
            <p className="font-mono text-[12px] text-parchment/60 leading-[1.8]" data-id="element-118">
              A boutique interior design studio.
              <br data-id="element-119" />
              Scottsdale, Arizona.
            </p>
          </div>

          {/* Center Column */}
          <div className="flex flex-col items-center text-center" data-id="element-120">
            <nav className="flex flex-col gap-2" data-id="element-121">
              {['home', 'studio', 'the practice', 'resonance', 'the journal', 'begin a project'].map(item => <a key={item} href={`#${item.split(' ').pop()}`} className="font-mono text-[14px] lowercase text-parchment/70 hover:text-parchment transition-colors leading-[2.4]" data-id="element-122">
                  {item}
                </a>)}
            </nav>
          </div>

          {/* Right Column */}
          <div className="flex flex-col items-center md:items-end text-center md:text-right" data-id="element-123">
            <p className="font-serif italic text-parchment text-[18px] max-w-[240px] mb-4" data-id="element-124">
              "The most beautiful rooms are the ones that remember you."
            </p>
            <p className="font-mono text-[12px] text-parchment/60" data-id="element-125">— a.p.</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-parchment/10" data-id="element-126">
          <p className="font-mono text-[11px] text-parchment/40 uppercase tracking-wide" data-id="element-127">
            © 2026 THE SPACES BETWEEN LLC. ALL RIGHTS RESERVED.
          </p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-parchment/60 hover:text-parchment transition-colors inline-flex items-center justify-center p-2 -m-2" data-id="element-128">
            <Instagram className="w-6 h-6" strokeWidth={1.5} data-id="element-129" />
          </a>
        </div>
      </div>
    </footer>;
}